import React, { useState, useEffect } from "react";
import { s3Link } from "../../utils/constants";
import ViewStory from "../ViewStory";
import { useSelector } from "react-redux";

import "./style.scss";

const Avatar = ({
    size = "auto",
    pu = {},
    story = true,
    bordered = false,
    blueBorder = false,
    showOnline = false,
    photoSize = null,
    ...rest
}) => {
    const [isOnline, setIsOnline] = useState(false);
    const [showStory, setShowStory] = useState(false);
    const [avatar, setAvatar] = useState("");
    const [puId, setPuId] = useState(null);
    const userInformation = JSON.parse(localStorage.getItem("user"));

    const presence = useSelector((state) => state.user.presence);

    useEffect(() => {
        let mounted = true;
        const tmpId = parseInt(pu.id);
        setPuId(tmpId);

        return () => {
            mounted = false;
        };
    }, [pu]);

    const handleSetShowStory = (e) => {
        e.preventDefault();
        setShowStory(!showStory);
    };

    useEffect(() => {
        if (puId) {
            if (pu.profile_pic || pu.other_user_pic) {
                const accessDate = pu.profile_photo_updated_at
                    ? pu.profile_photo_updated_at
                    : new Date().valueOf();
                setAvatar(
                    `${s3Link}/${parseInt(
                        pu.id
                    )}/profile_photo.jpg?t=${accessDate}`
                );
            } else {
                setAvatar("");
            }
        }
    }, [puId]);

    useEffect(() => {
        let mounted = true;
        if (
            presence &&
            presence.length > 0 &&
            presence.includes(parseInt(pu.id))
        ) {
            setIsOnline(true);
        } else {
            setIsOnline(false);
        }
        return () => {
            mounted = false;
        };
    }, [presence]);

    const handleHide = () => {
        setShowStory(false);
    };

    const style = () => {
        let tmp = {
            width: `${
                story && Object.keys(pu).length > 0 && pu.stories_count > 0
                    ? parseInt(size) + 4
                    : size
            }px`,
            height: `${
                story && Object.keys(pu).length > 0 && pu.stories_count > 0
                    ? parseInt(size) + 4
                    : size
            }px`,
            objectFit: "cover",
            borderRadius: "50%",
            display: "flex",
            verticalAlign: "middle",
            overflow: "hidden",
            alignItems: "center",
            justifyContent: "center",
            border: `${blueBorder ? " 2px solid #1434a4" : ""}`,
            color: "#fcfcfc",
        };

        if (photoSize) {
            tmp.fontSize = `${photoSize}px`;
        }

        return tmp;
    };

    return (
        <>
            {story && Object.keys(pu).length > 0 && showStory && (
                <ViewStory
                    show={showStory}
                    onHide={handleHide}
                    currentUser={userInformation}
                    user={pu}
                    avatar={avatar}
                />
            )}
            <div className="avatar" {...rest}>
                {story &&
                Object.keys(pu).length > 0 &&
                pu.stories_count > 0 &&
                pu.subscription_status === 0 ? (
                    <span
                        className="shadow-sm has-stories"
                        onClick={handleSetShowStory}
                        style={style()}
                    >
                        {avatar ? (
                            <span
                                style={{
                                    backgroundColor: "#ffffff",
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={avatar}
                                    width={size}
                                    height={size}
                                    style={{
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                    }}
                                />
                            </span>
                        ) : (
                            <span
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <svg
                                    width={"50px"}
                                    style={{
                                        backgroundColor: "#ffffff",
                                        width: size,
                                        height: size,
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path
                                        fill="#0097fe"
                                        d="M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
                                    />
                                </svg>
                            </span>
                        )}
                    </span>
                ) : (
                    <span
                        className={`shadow-sm${
                            bordered ? " avatar__bordered" : ""
                        }`}
                        style={style()}
                    >
                        {avatar ? (
                            <span
                                style={{
                                    backgroundColor: "#ffffff",
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={avatar}
                                    width={size}
                                    height={size}
                                    style={{
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                    }}
                                />
                            </span>
                        ) : (
                            <span
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <svg
                                    width={"50px"}
                                    style={{
                                        backgroundColor: "#ffffff",
                                        width: size,
                                        height: size,
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path
                                        fill="#0097fe"
                                        d="M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
                                    />
                                </svg>
                            </span>
                        )}
                    </span>
                )}

                {isOnline && showOnline && (
                    <span className="avatar__online-indicator avatar__online-indicator-online"></span>
                )}
            </div>
        </>
    );
};

export default Avatar;
